<script lang="ts" setup>
import { NModal } from 'naive-ui'
import CButton from '@lib/components/CButton/CButton.vue'
import CCard from '@lib/components/CCard/CCard.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

interface Props {
  modelValue: boolean
  cancelText?: string
  confirmText?: string
  exitText?: string
  hasExit?: boolean
  title?: string
  isDelete?: boolean
  isCancel?: boolean
  appendTo?: HTMLElement | string
}

withDefaults(defineProps<Props>(), {
  isCancel: true,
})

const emit = defineEmits<{
  (e: 'confirm'): void
  (e: 'deny'): void
  (e: 'update:modelValue', value: boolean): void
}>()
</script>

<template>
  <NModal
    class="p-4 c-confirmation-modal"
    :show="modelValue"
    :to="appendTo ?? 'body'"
    transform-origin="center"
    @update:show="emit('update:modelValue', $event)"
  >
    <CCard :bordered="false" class="c-confirmation-modal__card" size="medium">
      <div class="c-confirmation-modal__header">
        <slot name="header">
          <div class="font-normal c-confirmation-modal__title">
            {{ title }}
          </div>
        </slot>
      </div>
      <slot />
      <div class="mt-9 c-confirmation-modal__footer">
        <slot name="footer">
          <div class="flex flex-grow flex-wrap justify-between">
            <CButton v-if="isCancel" :bordered="false" type="default" @click="emit('update:modelValue', false)">
              {{ cancelText ?? t('canvasUI.common.cancel') }}
            </CButton>
            <CButton
              v-if="hasExit"
              class="ml-auto"
              @click="
                () => {
                  emit('update:modelValue', false)
                  emit('deny')
                }
              "
            >
              {{ exitText ?? t('canvasUI.common.no') }}
            </CButton>
            <CButton
              class="ml-auto"
              :type="isDelete ? 'error' : 'primary'"
              @click="
                () => {
                  emit('update:modelValue', false)
                  emit('confirm')
                }
              "
            >
              {{ confirmText ?? t('canvasUI.common.confirm') }}
            </CButton>
          </div>
        </slot>
      </div>
    </CCard>
  </NModal>
</template>

<style lang="scss" scoped>
.c-confirmation-modal {
  width: 500px;

  &__title {
    font-size: 20px;
    line-height: 32px;
    letter-spacing: 0.25px;
  }
}
</style>
